import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { CalendarDays, Download } from "lucide-react";

const TYPES = { campaign: "Campanya", fair: "Fira", training: "Formació", meeting: "Reunió", activity: "Activitat" };

function toICS(ev) {
  const fmt = (iso) => new Date(iso).toISOString().replace(/[-:]|\.\d{3}/g, "");
  return `BEGIN:VCALENDAR\nVERSION:2.0\nBEGIN:VEVENT\nUID:${ev.id}@shoppingsalou\nDTSTAMP:${fmt(new Date().toISOString())}\nDTSTART:${fmt(ev.start_date)}\nDTEND:${fmt(ev.end_date)}\nSUMMARY:${ev.title}\nDESCRIPTION:${(ev.description || "").replace(/\n/g, "\\n")}\nLOCATION:${ev.location || ""}\nEND:VEVENT\nEND:VCALENDAR`;
}

export default function AssocAgenda() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(new Date());

  useEffect(() => { api.get("/events").then(({ data }) => setItems(data)); }, []);

  const downloadICS = (ev) => {
    const blob = new Blob([toICS(ev)], { type: "text/calendar" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = `${ev.title}.ics`; a.click();
  };

  const eventDates = items.map(i => new Date(i.start_date));

  return (
    <div className="space-y-6" data-testid="assoc-agenda">
      <div>
        <div className="overline text-accent">Calendari</div>
        <h1 className="mt-2 text-3xl font-heading font-bold tracking-tight">Agenda</h1>
      </div>
      <div className="grid lg:grid-cols-3 gap-6">
        <Card className="rounded-2xl border-2 lg:col-span-1">
          <CardContent className="p-4">
            <Calendar mode="single" selected={selected} onSelect={setSelected} modifiers={{ event: eventDates }} modifiersClassNames={{ event: "bg-accent/30 rounded-full font-bold" }} />
          </CardContent>
        </Card>
        <div className="lg:col-span-2 space-y-3">
          {items.map(e => (
            <Card key={e.id} className="rounded-2xl border-2" data-testid={`assoc-event-${e.id}`}>
              <CardContent className="p-5 flex items-start gap-4">
                <div className="w-14 h-14 rounded-xl bg-primary text-primary-foreground flex flex-col items-center justify-center text-[10px] font-bold">
                  <div>{new Date(e.start_date).toLocaleDateString("ca", { month: "short" }).toUpperCase()}</div>
                  <div className="text-lg">{new Date(e.start_date).getDate()}</div>
                </div>
                <div className="flex-1">
                  <div className="text-xs uppercase tracking-widest text-accent font-semibold">{TYPES[e.type] || e.type}</div>
                  <div className="font-heading font-semibold text-lg mt-0.5">{e.title}</div>
                  <div className="text-sm text-muted-foreground">{e.description}</div>
                  <div className="text-xs text-muted-foreground mt-1">
                    <CalendarDays className="w-3.5 h-3.5 inline mr-1" /> {new Date(e.start_date).toLocaleString()} · {e.location}
                  </div>
                </div>
                <Button size="sm" variant="outline" className="rounded-full" onClick={() => downloadICS(e)} data-testid={`event-ics-${e.id}`}>
                  <Download className="w-3.5 h-3.5 mr-1" /> .ics
                </Button>
              </CardContent>
            </Card>
          ))}
          {items.length === 0 && <div className="text-muted-foreground text-sm">Sense esdeveniments programats.</div>}
        </div>
      </div>
    </div>
  );
}
